<template>
    <app-modal modal-id="inviteModal" modal-size="default" modal-alignment="top" @close-modal="closeModal">
        <template slot="header">
            <h5 v-if="selectedUrl" class="modal-title">{{ $t('edit') }}</h5>
            <h5 v-else class="modal-title">{{ $t('add') }}</h5>
            <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <form ref="form" data-url='admin/auth/users/invite-user'>
                <div class="form-group">
                    <label>{{ $t('email') }}</label>
                    <app-input
                        :placeholder="$t('email')"
                        v-model="invite.email"
                        :required="true"
                    />
                    <small class="text-danger" v-if="errors.email">{{errors.email[0]}}</small>
                </div>

                <div class="form-group">
                    <label>{{ $t('roles') }}</label>
                    <app-input type="multi-select"
                               list-value-field="name"
                               :list="roleList"
                               :required="true"
                               v-model="invite.roles"/>
                    <small class="text-danger" v-if="errors.roles">{{errors.roles[0]}}</small>
                </div>

            </form>
        </template>

        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click.prevent="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click.prevent="submitData">
                        <span class="w-100">
                            <app-submit-button-loader v-if="loading"></app-submit-button-loader>
                        </span>
                <template v-if="!loading">{{ $t('invite') }}</template>
            </button>
        </template>
    </app-modal>
</template>

<script>
    import {FormMixin} from "@core/mixins/form/FormMixin.js";

    export default {
        name: "UserInviteModal",
        mixins: [FormMixin],
        props: {
            tableId: String
        },
        data(){
            return{
                roleList:[],
                invite:{roles:[]},
                formData:{},
                loading: false,
                errors:[]
            }
        },
        methods: {
            beforeSubmit(){
                this.loading = true;
            },
            submitData() {
                this.save(this.invite);
            },
            afterError(response) {
                this.loading = false;
                this.errors = response.data.errors;
            },

            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-'+this.tableId);
                this.closeModal();
            },

            afterFinalResponse() {
                this.loading = false;
            },

            afterSuccessFromGetEditData(response) {
                this.formData = response.data;
            },
            closeModal(value) {
                this.$emit('close-modal', value);
            },
            getAllRoles(){
                this.axiosGet('admin/auth/roles').then(response =>{
                    this.roleList = response.data.data;
                }).catch(({error}) => {});
            }
        },

        mounted(){
            this.getAllRoles();
        }


    }
</script>

